function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from "react";
import { Field, Form as FormikForm, Formik } from "formik";
import * as Yup from "yup";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import ControlLabel from "react-bootstrap/FormLabel";
import FormControl from "react-bootstrap/FormControl";
import FormGroup from "react-bootstrap/FormGroup";
import Button from "react-bootstrap/Button";
import jwtDecode from "jwt-decode";
import { UserContext } from "../index";
import { HiOutlineExclamation, HiOutlineClock, HiOutlineCheckCircle } from "react-icons/hi";
import { useQuery, useMutation } from "@apollo/client";
import { ACCOUNT_CREATION_MUTATION, INVITE_TEAM_QUERY, DOWNLOAD_LINK_QUERY } from "./query";
import "./WebPageSignUp.css";
import Profile from "../img/workfolio-latest.png";
import { Helmet } from "react-helmet";
import ReCaptcha from "react-google-recaptcha";
import Loader from "./../Loader/Loader";
import { browserName, deviceType, isDesktop, osName, isMobile } from "react-device-detect";
import { FaLinux } from "react-icons/fa";
import Turnstile, { useTurnstile } from "react-turnstile";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { FiUsers } from "react-icons/fi";
import { AiOutlineExclamationCircle } from "react-icons/ai";
var SITEKEY = "6LeeddsbAAAAAIP2zpTS21Lbz5ZMCb-CdWj1ubSm";

// The ad click identifiers carried by the signup URL (/signup/pro?gclid=..).
// Only these are kept: the rest of a campaign query string is either useless to
// us later (the GA linker _gl expires within minutes) or something we would
// rather not persist next to a user row, since marketing links routinely carry
// email addresses and tokens.
var ATTRIBUTION_PARAMS = ["gclid", "gbraid", "wbraid"];

// anyone can request /signup/pro?gclid=<100KB>, so cap each value we keep
var MAX_ATTRIBUTION_VALUE_LENGTH = 2000;
var SIGNUP_ATTRIBUTION_CACHE_KEY = "signupAttribution";

// "?gclid=abc&_gl=..&gbraid=xyz" -> { gclid: "abc", gbraid: "xyz", wbraid: null }
// Each identifier is kept on its own so it can be stored and queried as its own
// column rather than as a query string that has to be parsed again later.
export var extractAttributionParams = function extractAttributionParams(search) {
  var attribution = {
    gclid: null,
    gbraid: null,
    wbraid: null
  };
  if (!search) return attribution;
  try {
    var source = new URLSearchParams(search);
    ATTRIBUTION_PARAMS.forEach(function (name) {
      var value = source.get(name);
      if (value) attribution[name] = value.slice(0, MAX_ATTRIBUTION_VALUE_LENGTH);
    });
  } catch (error) {
    // malformed query string: leave every identifier null
  }
  return attribution;
};
var hasAttribution = function hasAttribution(attribution) {
  return Boolean(attribution) && ATTRIBUTION_PARAMS.some(function (name) {
    return attribution[name];
  });
};
var cacheSignupAttribution = function cacheSignupAttribution(attribution) {
  if (!hasAttribution(attribution)) return;
  try {
    localStorage.setItem(SIGNUP_ATTRIBUTION_CACHE_KEY, JSON.stringify(attribution));
  } catch (error) {
    // storage unavailable: the identifiers simply are not remembered
  }
};
export var getCachedSignupAttribution = function getCachedSignupAttribution() {
  try {
    var cached = localStorage.getItem(SIGNUP_ATTRIBUTION_CACHE_KEY);
    return cached ? JSON.parse(cached) : null;
  } catch (error) {
    // unavailable, or left unparseable by an older build
    return null;
  }
};
var WebPageSignUp = function WebPageSignUp(props) {
  var _props$match, _props$location$searc, _props$location, _inviteTeamData$invit, _inviteTeamData$invit2, _linkData$appDownload, _linkData$appDownload2, _inviteTeamData$invit3;
  var history = props === null || props === void 0 ? void 0 : props.history;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    users = _useState2[0],
    setUsers = _useState2[1];
  var _props$match$params = props === null || props === void 0 ? void 0 : (_props$match = props.match) === null || _props$match === void 0 ? void 0 : _props$match.params,
    link = _props$match$params.link;

  //  WORKFOLIO MAINTENANCE REDIRECTION
  // React.useEffect(() => {
  //   props?.history.push("/workfolio-maintenance");
  // }, []);

  var inviteLink = null;
  var planType = null;
  if (link === "free" || link === "pro" || link === "enterprise" || link === "startup" || link === "premium") {
    planType = link;
  } else {
    inviteLink = link;
  }
  planType = inviteLink === null ? planType : "free";

  // the ad click ids from the landing URL, each on its own
  var landingAttribution = extractAttributionParams((_props$location$searc = props === null || props === void 0 ? void 0 : (_props$location = props.location) === null || _props$location === void 0 ? void 0 : _props$location.search) !== null && _props$location$searc !== void 0 ? _props$location$searc : window.location.search);

  // On load only: [] deps, so a re-render or a later navigation inside signup
  // cannot overwrite what the landing URL carried. Declared above the early
  // return below, or the hook order would change between renders.
  React.useEffect(function () {
    cacheSignupAttribution(landingAttribution);
  }, []);

  // this load's identifiers win; otherwise fall back to what an earlier load
  // cached, since the ad parameters leave the URL as soon as the user moves
  var cachedAttribution = getCachedSignupAttribution() || {};
  var gclid = landingAttribution.gclid || cachedAttribution.gclid || null;
  var gbraid = landingAttribution.gbraid || cachedAttribution.gbraid || null;
  var wbraid = landingAttribution.wbraid || cachedAttribution.wbraid || null;
  var _useQuery = useQuery(INVITE_TEAM_QUERY, {
      variables: {
        inviteLink: inviteLink ? inviteLink : ""
      }
    }),
    inviteTeamData = _useQuery.data,
    inviteTeamDataError = _useQuery.error,
    inviteTeamDataLoading = _useQuery.loading;
  var _useQuery2 = useQuery(DOWNLOAD_LINK_QUERY, {}),
    linkData = _useQuery2.data,
    linkError = _useQuery2.error,
    linkLoading = _useQuery2.loading,
    refetch = _useQuery2.refetch;
  if (inviteTeamDataLoading && inviteLink) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, "Workfolio | SignUp")), /*#__PURE__*/React.createElement(AccountCreation, {
    history: history,
    setUsers: setUsers,
    inviteLink: inviteLink,
    teamName: inviteTeamData === null || inviteTeamData === void 0 ? void 0 : (_inviteTeamData$invit = inviteTeamData.inviteTeamDetails) === null || _inviteTeamData$invit === void 0 ? void 0 : _inviteTeamData$invit.teamName,
    tokenStatus: inviteTeamData === null || inviteTeamData === void 0 ? void 0 : (_inviteTeamData$invit2 = inviteTeamData.inviteTeamDetails) === null || _inviteTeamData$invit2 === void 0 ? void 0 : _inviteTeamData$invit2.tokenStatus,
    macLink: linkData === null || linkData === void 0 ? void 0 : (_linkData$appDownload = linkData.appDownloadLink) === null || _linkData$appDownload === void 0 ? void 0 : _linkData$appDownload.mac,
    windowsLink: linkData === null || linkData === void 0 ? void 0 : (_linkData$appDownload2 = linkData.appDownloadLink) === null || _linkData$appDownload2 === void 0 ? void 0 : _linkData$appDownload2.windows
    //linkData={linkData}
    ,
    planType: planType,
    userStatus: inviteTeamData === null || inviteTeamData === void 0 ? void 0 : (_inviteTeamData$invit3 = inviteTeamData.inviteTeamDetails) === null || _inviteTeamData$invit3 === void 0 ? void 0 : _inviteTeamData$invit3.userStatus,
    inviteTeamData: inviteTeamData,
    gclid: gclid,
    gbraid: gbraid,
    wbraid: wbraid
  }));
};
var AccountSchema = Yup.object().shape({
  name: Yup.string().trim().required("Required").matches(/^[\u4E00-\u9FFF A-Za-z0-9'.-]+$/, "Invalid characters").min(3, "*Required atleast 3 characters"),
  email: Yup.string().trim().required("Required").email("*Must be a valid email address").matches(/^[^\s@+]+@[^\s@]+\.[^\s@]+$/, "The '+' symbol is not allowed."),
  password: Yup.string().trim().required("Password is required").min(6, "Password must be at least 6 characters").max(64, "Password must be at most 64 characters")
});
function validateUsername(value) {
  var error = "";
  if (!value) {
    error = "Required";
    return error;
  } else if (/^[0-9\b]+$/.test(value)) {
    //console.error(); = 'Required';
    error = "Enter character only";
    return error;
  }
}
var AccountCreation = function AccountCreation(props) {
  var _inviteTeamData$invit4, _inviteTeamData$invit5;
  var setUsers = props.setUsers,
    history = props.history,
    inviteLink = props.inviteLink,
    teamName = props.teamName,
    tokenStatus = props.tokenStatus,
    macLink = props.macLink,
    windowsLink = props.windowsLink,
    planType = props.planType,
    userStatus = props.userStatus,
    inviteTeamData = props.inviteTeamData,
    gclid = props.gclid,
    gbraid = props.gbraid,
    wbraid = props.wbraid;
  var turnstile = useTurnstile();
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    status = _useState4[0],
    setStatus = _useState4[1];
  var userCtx = React.useContext(UserContext);
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    cloudFlareToken = _useState6[0],
    setCloudFlareToken = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showPassword = _useState8[0],
    setShowPassword = _useState8[1];

  // let captchaRef = React.useRef(null);

  var _useMutation = useMutation(ACCOUNT_CREATION_MUTATION),
    _useMutation2 = _slicedToArray(_useMutation, 2),
    createUser = _useMutation2[0],
    createUserLoading = _useMutation2[1].loading;
  var handleSubmit = React.useCallback( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(values, _ref) {
      var setFieldError, browser, ipAddress, location, timezone, variables, response, _localStorage, _localStorage$setItem, _userCtx$setUser, responseData;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setFieldError = _ref.setFieldError;
            //const planType = "free";
            browser = browserName;
            _context.prev = 2;
            ipAddress = null;
            location = null;
            if (!(window.navigator.brave === undefined || window.navigator.brave.isBrave.name != "isBrave")) {
              _context.next = 10;
              break;
            }
            _context.next = 8;
            return fetch("https://www.cloudflare.com/cdn-cgi/trace").then(function (res) {
              return res.text();
            }).then(function (res) {
              var _res$split$find, _res$split$find2;
              ipAddress = (_res$split$find = res.split(/\n/g).find(function (n) {
                return n.includes("ip=");
              })) === null || _res$split$find === void 0 ? void 0 : _res$split$find.replace("ip=", "");
              location = (_res$split$find2 = res.split(/\n/g).find(function (n) {
                return n.includes("loc=");
              })) === null || _res$split$find2 === void 0 ? void 0 : _res$split$find2.replace("loc=", "");
            });
          case 8:
            _context.next = 12;
            break;
          case 10:
            ipAddress = "brave browser";
            browser = "Brave";
          case 12:
            timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            variables = {
              authType: "email",
              username: values.name,
              email: values.email,
              password: values.password,
              accessToken: null,
              planType: planType,
              inviteLink: inviteLink ? inviteLink : null,
              recaptchaToken: cloudFlareToken,
              // recaptchaToken: null,
              ipAddress: ipAddress,
              location: location,
              browserName: browser,
              deviceType: deviceType,
              osName: osName,
              deviceMedium: isDesktop == true ? "desktop" : isMobile == true ? "mobile" : null,
              timezone: timezone,
              // the ad click identifiers, each sent on its own
              gclid: gclid,
              gbraid: gbraid,
              wbraid: wbraid
            };
            _context.next = 16;
            return createUser({
              variables: variables,
              awaitRefetchQueries: true
            });
          case 16:
            response = _context.sent;
            if (!(!response || !response.data || response.data.createUser == null)) {
              _context.next = 21;
              break;
            }
            throw new Error("error");
          case 21:
            //const users = jwtDecode(response.data.createUser);
            //setUsers(users);
            if (response.data.createUser) {
              if (inviteLink) {
                setStatus(true);
                //props?.history.push("/member-overview");
              } else {
                responseData = jwtDecode(response.data.createUser);
                if (typeof window.gr === "function") {
                  // 👇️ this runs
                  console.log("✅ gr function is defined");
                  if (responseData && responseData !== null && responseData !== void 0 && responseData.emailId) {
                    console.log({
                      responseData: responseData,
                      emailId: responseData === null || responseData === void 0 ? void 0 : responseData.emailId
                    });
                    window.gr("track", "conversion", {
                      email: responseData === null || responseData === void 0 ? void 0 : responseData.emailId
                    });
                  }
                } else {
                  console.log("⛔️ gr function is NOT defined"); // Normally this means the gr function wasn't declared here, try and look why the Tracking Script isn't running on this page
                }
                (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : (_localStorage$setItem = _localStorage.setItem) === null || _localStorage$setItem === void 0 ? void 0 : _localStorage$setItem.call(_localStorage, "token", response.data.createUser);
                userCtx === null || userCtx === void 0 ? void 0 : (_userCtx$setUser = userCtx.setUser) === null || _userCtx$setUser === void 0 ? void 0 : _userCtx$setUser.call(userCtx, jwtDecode(response.data.createUser));
                props === null || props === void 0 ? void 0 : props.history.push({
                  pathname: "/on-boarding/".concat(planType),
                  state: {
                    from: "signup"
                  }
                });
                // props?.history.push("/on-boarding");

                // props?.history.push("/on-boarding", { from: "signup" });
              }
            }
          case 22:
            _context.next = 29;
            break;
          case 24:
            _context.prev = 24;
            _context.t0 = _context["catch"](2);
            console.log({
              error: _context.t0
            });

            // captchaRef.current.reset();
            if (_context.t0.message.includes("already registered")) {
              setFieldError("formError", _context.t0.message);
            } else if (_context.t0.message.includes("User with the email already exists")) {
              setFieldError("email", "User with the email already exists");
            } else if (_context.t0.message.includes("Link expire")) {
              setFieldError("formError", "Your invite link has been expired.");
            } else if (_context.t0.message.includes("more than 200 users are not allowed")) {
              // The server throws "more than 200 users are not allowed." from
              // graphql/models/user.js - the check here used to look for 500, so it
              // never matched and the raw server text reached the form instead.
              // Wording kept identical to the same branch in Employees/EmployeesModal.js.
              setFieldError("formError", /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", {
                style: {
                  fontWeight: 700
                }
              }, "You've reached the 200-user limit"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
                style: {
                  fontWeight: 400
                }
              }, "For security and to prevent automated abuse, Free plan workspaces can add up to 200 users by default.", /*#__PURE__*/React.createElement("br", null), "If you need to add more users, please contact us through Support Chat or email (team@getworkfolio.com).", /*#__PURE__*/React.createElement("br", null), "We're happy to review your workspace and increase the limit for legitimate use.")));
            } else {
              setFieldError("formError", _context.t0.message);
            }
            turnstile.reset();
          case 29:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 24]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }(), [createUser, createUserLoading, cloudFlareToken, gclid, gbraid, wbraid]);

  // const setCaptchaRef = (ref) => {
  //   if (ref) {
  //     return (captcha = ref);
  //   }
  // };

  return /*#__PURE__*/React.createElement(React.Fragment, null, !status ? /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: "text-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "account-creation-logo-full"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "Workfolio",
    src: Profile,
    className: "account-root-img-responsive login-root-img-center m-b-20",
    width: "40",
    height: "40"
  })), inviteLink ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", null, "Hello, You are invited to join workfolio!"), (inviteTeamData === null || inviteTeamData === void 0 ? void 0 : (_inviteTeamData$invit4 = inviteTeamData.inviteTeamDetails) === null || _inviteTeamData$invit4 === void 0 ? void 0 : _inviteTeamData$invit4.licenseStatus) != "license not available" && tokenStatus != "deleted" ? /*#__PURE__*/React.createElement("h5", {
    className: "on-boarding-root-header-invite"
  }, "Create an account to join your ", teamName) : null) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h1", {
    className: "on-boarding-root-header"
  }, "Admin Registration"), /*#__PURE__*/React.createElement("h6", {
    className: "on-boarding-root-sub-header"
  }, "Create a new organization admin account here. This option is only for organization administrators."), /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-header-warning-card"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FiUsers, {
    className: "on-boarding-root-header-warning-card-icon"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h6", {
    className: "on-boarding-root-header-warning-card-text"
  }, "\u26A0\uFE0F Team Members - DO NOT Register Here!"), /*#__PURE__*/React.createElement("h6", {
    className: "on-boarding-root-header-warning-card-text-1"
  }, "If you want to join your company on Workfolio, you must get an invite link from your Workfolio admin. Click and open that invite link to create your account. Do NOT create a new organization account here.")))))), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: ""
  }, inviteLink && tokenStatus === "Token expired" ? /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full-icon-div"
  }, /*#__PURE__*/React.createElement(HiOutlineClock, {
    className: "on-boarding-root-content-full-icon"
  })), /*#__PURE__*/React.createElement("p", {
    className: "on-boarding-root-content-full-invite-err"
  }, "Your invite link has been expired. Please ask your admin/team head to generate a new invite link.")) : inviteLink && tokenStatus === "deleted" ? /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full-icon-div"
  }, /*#__PURE__*/React.createElement(HiOutlineClock, {
    className: "on-boarding-root-content-full-icon"
  })), /*#__PURE__*/React.createElement("p", {
    className: "on-boarding-root-content-full-invite-invalid-err"
  }, "Dear user, The invite link is invalid. Kindly get the new invite link from your workfolio admin.")) : (inviteTeamData === null || inviteTeamData === void 0 ? void 0 : (_inviteTeamData$invit5 = inviteTeamData.inviteTeamDetails) === null || _inviteTeamData$invit5 === void 0 ? void 0 : _inviteTeamData$invit5.licenseStatus) == "license not available" ? /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full on-boarding-root-content-full-license-not-available"
  }, /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full-icon-div"
  }, /*#__PURE__*/React.createElement(HiOutlineExclamation, {
    className: "on-boarding-root-content-full-icon"
  })), /*#__PURE__*/React.createElement("p", {
    className: "on-boarding-root-content-full-invite-license-err"
  }, "Please instruct your admin to purchase user license to join you in team."), /*#__PURE__*/React.createElement("p", {
    className: "on-boarding-root-content-full-invite-license"
  }, "After purchasing the license, you can use this same link to join the team.")) : /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-content-full"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: {
      name: "",
      email: "",
      password: "",
      recaptchaToken: ""
    }
    // Hooks up our validationSchema to Formik
    ,
    validationSchema: AccountSchema,
    onSubmit: handleSubmit
    // validateOnBlur={false}
    ,
    validateOnBlur: true
  }, function (_ref3) {
    var isSubmitting = _ref3.isSubmitting,
      values = _ref3.values,
      errors = _ref3.errors,
      setFieldValue = _ref3.setFieldValue,
      setFieldError = _ref3.setFieldError,
      setSubmitting = _ref3.setSubmitting,
      submitForm = _ref3.submitForm;
    return /*#__PURE__*/React.createElement(FormikForm, null, /*#__PURE__*/React.createElement(Row, {
      className: "on-boarding-root-content-form"
    }, /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "name",
      validate: validateUsername
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta,
        form = fieldProps.form;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, inviteLink ? "Name" : "Admin Name"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error-signup"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "name",
        type: "text",
        placeholder: "Your name"
        // onBlur={handleBlur}
      }, field, {
        autoFocus: true
      })));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "email"
    }, function (fieldProps) {
      var field = fieldProps.field,
        meta = fieldProps.meta;
      return /*#__PURE__*/React.createElement(FormGroup, null, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, inviteLink ? "Email" : "Admin Email"), meta.error && meta.touched ? /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error-signup"
      }, meta.error) : null, /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "email",
        type: "email",
        placeholder: "Your email"
        // onBlur={handleBlur}
      }, field)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement(Field, {
      name: "password"
    }, function (_ref4) {
      var field = _ref4.field,
        meta = _ref4.meta;
      return /*#__PURE__*/React.createElement(FormGroup, {
        className: "mb-3 position-relative forms-pass"
      }, /*#__PURE__*/React.createElement(ControlLabel, {
        className: "manage-teams-edit-task-label-name"
      }, "Password"), meta.error && meta.touched && /*#__PURE__*/React.createElement(ControlLabel, {
        className: "error-signup"
      }, meta.error), /*#__PURE__*/React.createElement(FormControl, _extends({
        name: "password",
        type: showPassword ? "text" : "password",
        placeholder: "Your password"
      }, field)), /*#__PURE__*/React.createElement("span", {
        className: "signup-password-view-icon",
        onClick: function onClick() {
          return setShowPassword(!showPassword);
        },
        "aria-label": "Toggle password visibility",
        role: "button"
      }, showPassword ? /*#__PURE__*/React.createElement(AiOutlineEyeInvisible, null) : /*#__PURE__*/React.createElement(AiOutlineEye, null)));
    })), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "captcha-container"
    }, /*#__PURE__*/React.createElement(Turnstile, {
      sitekey: "0x4AAAAAAATfrCMYZGKE2jTf",
      onVerify: function onVerify(token) {
        console.log({
          token: token
        });
        setCloudFlareToken(token);
      },
      onError: function onError(token) {
        setFieldError("formError", "Please refresh the page once, fill in the required details, then click the button below to complete your signup.");
      },
      onExpire: function onExpire(token) {
        console.log("expire enter");
        turnstile.reset();
      },
      onTimeout: function onTimeout(token) {
        console.log("timeout enter");
        turnstile.reset();
      },
      onUnsupported: function onUnsupported(token) {
        setFieldError("formError", "CAPTCHA not supported; please update or switch your browser, or contact support if issue continues.");
      },
      size: "normal",
      className: "web-page-signup-cloudflare-recaptcha",
      theme: "light",
      style: {
        width: "100%"
      }
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, /*#__PURE__*/React.createElement("div", {
      className: "web-page-signup-terms-and-condition-text"
    }, "By signing up, you agree to our", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      className: "web-page-signup-terms-and-condition-terms-text",
      href: "https://www.getworkfolio.com/tos"
    }, "Terms"), " ", "&", " ", /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      className: "web-page-signup-terms-and-condition-condition-text",
      href: "https://www.getworkfolio.com/privacy"
    }, "Privacy Policy"))), /*#__PURE__*/React.createElement(Col, {
      xs: 12,
      md: 12
    }, errors.formError ? /*#__PURE__*/React.createElement("div", {
      className: "error-link"
    }, errors.formError) : null, errors.formError === "Your invite link has been expired." ? /*#__PURE__*/React.createElement("div", {
      className: "error-link-admin-text"
    }, "Please inform your admin to resend the invite link") : null, /*#__PURE__*/React.createElement(Button, {
      className: "on-boarding-root-content-form-account-submit-button"
      // type="submit"
      ,
      disabled: isSubmitting,
      onClick: function onClick() {
        if (cloudFlareToken) {
          setSubmitting(false);
          submitForm();
        } else {
          setFieldError("formError", "Please refresh the page once, fill in the required details, then click the button below to complete your signup.");
          // captchaRef.current.execute();
        }
      }
    }, inviteLink ? "Sign Up" : "Create an admin account"))));
  }), !inviteLink ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "account-root-footer font-weight-bold"
  }, "Already have an account?", /*#__PURE__*/React.createElement("a", {
    href: "https://app.getworkfolio.com/login",
    className: "font-weight-bold"
  }, " ", "Login")), /*#__PURE__*/React.createElement("div", null, " ", /*#__PURE__*/React.createElement("div", {
    className: "on-boarding-root-header-note-card"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(AiOutlineExclamationCircle, {
    className: "on-boarding-root-header-note-card-icon"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: "on-boarding-root-header-note-card-text-1"
  }, /*#__PURE__*/React.createElement("span", {
    className: "on-boarding-root-header-note-card-text"
  }, "Joining a company? "), "Contact your Workfolio admin to get your invite link. Only use this page if you are creating a NEW admin account for your company."))))) : null))) : /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 6,
      offset: 3
    },
    className: "text-center member-overview"
  }, /*#__PURE__*/React.createElement("div", {
    className: "create-password-content"
  }, /*#__PURE__*/React.createElement(HiOutlineCheckCircle, {
    className: "create-password-content-success-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "fs-18 m-b-16 text-center create-password-reset-success-msg1"
  }, "Your account has been created successfully!"), /*#__PURE__*/React.createElement("p", {
    className: "fs-18 m-b-16 text-center create-password-reset-success-msg2"
  }, "Now you can download and install workfolio on your device. Use your email and the password you created to log into the app after installation."), /*#__PURE__*/React.createElement("p", {
    className: "fs-18 m-b-16 text-center create-password-reset-success-msg3"
  }, "Download installation file for your operating system"), /*#__PURE__*/React.createElement("div", {
    className: "fs-18 m-b-16 text-center create-password-download-file-header"
  }, /*#__PURE__*/React.createElement("span", {
    className: "fs-18 m-b-16 text-center create-password-download-file-windows"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-windows-10-50.webp",
    alt: "windows",
    className: "create-password-download-file-windows-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "create-password-download-file-windows-text"
  }, /*#__PURE__*/React.createElement("a", {
    href: windowsLink,
    target: "_blank",
    "data-saferedirecturl": "https://workfolio-public.s3.ap-south-1.amazonaws.com/Workfolio%20Setup%200.1.5.exe"
  }, "Download for Windows"))), /*#__PURE__*/React.createElement("span", {
    className: "fs-18 m-b-16 text-center create-password-download-file-mac"
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://workfolio-public.s3.ap-south-1.amazonaws.com/icons8-mac-client-90.webp",
    alt: "mac",
    className: "create-password-download-file-mac-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "create-password-download-file-mac-text"
  }, /*#__PURE__*/React.createElement("a", {
    href: macLink,
    target: "_blank",
    "data-saferedirecturl": "https://workfolio-public.s3.ap-south-1.amazonaws.com/workfolio-0.1.5.dmg"
  }, "Download for Mac"))), /*#__PURE__*/React.createElement("span", {
    className: "fs-18 m-b-16 text-center create-password-download-file-linux"
  }, /*#__PURE__*/React.createElement(FaLinux, {
    className: "create-password-download-file-linux-icon"
  }), /*#__PURE__*/React.createElement("p", {
    className: "create-password-download-file-linux-text"
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://workfolio.tawk.help/article/workfolio-linux-application-installation-guide",
    target: "_blank",
    "data-saferedirecturl": "https://workfolio.tawk.help/article/workfolio-linux-application-installation-guide"
  }, "Download for Linux")))), /*#__PURE__*/React.createElement("div", {
    "class": "login-url"
  }, "Web Dashboard URL:", /*#__PURE__*/React.createElement("a", {
    href: "https://app.getworkfolio.com/"
  }, "https://app.getworkfolio.com/")))));
};
export default /*#__PURE__*/React.memo(WebPageSignUp);